import { useHistory } from "react-router-dom";

import { ReactComponent as Car } from "assets/car.svg";
import { ReactComponent as Home } from "assets/home.svg";
import { ReactComponent as Policeman } from "assets/SidebarIcons/orange-peoplesafeone.svg";

import * as S from "./styles";
import { IOccurrence } from "interfaces/Occurrence";
import { IGetByIdPoliceman } from "interfaces/Policeman";
import { RefObject, useState } from "react";
import { LatLngTuple } from "leaflet";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import ManualOccurrenceModal from "components/Modals/OccurrenceManagementModal";
import PicturesModal from "../PicturesModal";
import { MorePolicemanDetailsModal } from "components/Modals/MorePolicemanDetailsModal";
import { getPolicemanService } from "services/PolicemenServices";
import SuperficialPolicemanModal from "../SuperficialPolicemanModal";
import Loader from "components/Modals/OccurrenceManagementModal/Loader";

type SideBarProps = {
  occurrence: IOccurrence | null;
  map: RefObject<L.Map>;
  occurrenceLocation?: LatLngTuple;
  policemanLocation?: LatLngTuple;
  showPolicemanCoordinates: () => void;
};

export default function SideBar({
  map,
  occurrence,
  occurrenceLocation,
  policemanLocation,
  showPolicemanCoordinates,
}: SideBarProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isManagementModalOpen, setIsManagementModalOpen] =
    useState<boolean>(false);
  const [isPicturesModalOpen, setIsPicturesModalOpen] =
    useState<boolean>(false);
  const [isPolicemanDetailsModalOpen, setIsPolicemanDetailsModalOpen] =
    useState<boolean>(false);
  const [policemanData, setPolicemanData] = useState<IGetByIdPoliceman>();

  const history = useHistory();
  const { setOccurrenceToEditId, occurrenceToEdit } = useManualOccurrence();

  function setMapCenter(coordinates?: LatLngTuple) {
    if (!coordinates) return;

    map?.current?.flyTo(coordinates);
  }

  function handleManageOccurrence() {
    if (!occurrence) return;

    setIsManagementModalOpen(true);
    setOccurrenceToEditId(occurrence.id);
  }

  const isSuperficialRegister = !!occurrence?.report?.[0]?.superficialPoliceman
    ?.id
    ? true
    : false;

  async function fetchPolicemanData() {
    if (isSuperficialRegister) {
      setIsPolicemanDetailsModalOpen(true);
      return;
    }

    setIsLoading(true);

    const policemanId = occurrence?.policemen?.[0]?.policeman?.user?.id;

    if (policemanId) {
      const response = await getPolicemanService(policemanId);
      setPolicemanData(response.item);
      setIsPolicemanDetailsModalOpen(true);
    }

    setIsLoading(false);
  }

  const policemanName =
    occurrence?.report?.[0]?.superficialPoliceman?.name ||
    occurrence?.policemen?.[0]?.policeman?.user?.name;

  return (
    <S.Wrapper>
      <S.Column>
        <S.BackButtonContainer>
          <p onClick={() => history.push("/map")}>
            Voltar e visualizar o mapa geral
          </p>
        </S.BackButtonContainer>

        <S.DataSection>
          <S.Title>Ocorrência</S.Title>
          <S.Coordinate
            title="Visualizar no mapa"
            onClick={() => setMapCenter(occurrenceLocation)}
          >
            {occurrenceLocation?.[0]}, {occurrenceLocation?.[1]}
          </S.Coordinate>

          <S.OccurrenceTypeBadge>
            <S.OccurrenceIcon>
              {occurrence?.patrimonialType === 2 ? <Car /> : <Home />}
            </S.OccurrenceIcon>

            <S.OccurrenceType>
              <p>Roubo</p>
              <p>
                {occurrence?.patrimonialType === 2 ? "Veicular" : "Patrimonial"}
              </p>
            </S.OccurrenceType>
          </S.OccurrenceTypeBadge>

          {occurrence?.report?.[0]?.attachments && <button onClick={() =>setIsPicturesModalOpen(true)}>Anexos</button>}
          <button onClick={handleManageOccurrence}>Gerenciar ocorrência</button>
        </S.DataSection>

        <S.DataSection>
          <S.Title>Pronta-resposta</S.Title>
          {policemanLocation && policemanLocation.length > 0 && (
            <S.Coordinate
              title="Visualizar no mapa"
              onClick={() => setMapCenter(policemanLocation)}
            >
              {policemanLocation?.[0]}, {policemanLocation?.[1]}
            </S.Coordinate>
          )}

          {!policemanLocation && <p>Nenhuma coordenada registrada!</p>}

          <S.OccurrenceTypeBadge>
            <S.OccurrenceIcon>{<Policeman />}</S.OccurrenceIcon>

            <S.PolicemanName>
              <p>{policemanName}</p>
            </S.PolicemanName>
          </S.OccurrenceTypeBadge>
          <button onClick={showPolicemanCoordinates}>
            Visualizar trajeto do pronta resposta
          </button>
          <button onClick={fetchPolicemanData}>
            Ver dados do pronta-resposta
          </button>
        </S.DataSection>
      </S.Column>

      {occurrenceToEdit && (
        <ManualOccurrenceModal
          isOpen={isManagementModalOpen}
          setIsOpen={() => setIsManagementModalOpen(false)}
          type={occurrence?.patrimonialType === 2 ? "vehicular" : "patrimonial"}
        />
      )}

      {occurrence?.report?.[0]?.attachments && (
        <PicturesModal
          isOpen={isPicturesModalOpen}
          gallery={occurrence?.report?.[0]?.attachments ?? []}
          onCloseButtonClick={() => setIsPicturesModalOpen(false)}
        />
      )}

      {isLoading && <Loader color="white" size={90} />}

      {!isSuperficialRegister && !!policemanData && !isLoading && (
        <MorePolicemanDetailsModal
          modalIsOpen={isPolicemanDetailsModalOpen}
          setIsOpen={setIsPolicemanDetailsModalOpen}
          policeman={policemanData}
        />
      )}

      {isSuperficialRegister && !isLoading && (
        <SuperficialPolicemanModal
          superficialPoliceman={
            occurrence?.report?.[0]?.superficialPoliceman ?? null
          }
          modalIsOpen={isPolicemanDetailsModalOpen}
          onCloseButtonClick={() => setIsPolicemanDetailsModalOpen(false)}
        />
      )}
    </S.Wrapper>
  );
}
